import { AccountBalance, InternalAccount } from "@wingspanhq/wingspan-api-sdk";
import takeRight from "lodash/takeRight";

import { selectorAccountBalance } from "../../../shared/selectors/selectorAccountBalance";

/**
 * Wallet card model. A composite of the funding `InternalAccount` and its
 * `AccountBalance` — two v3 reads — so it has no single SDK counterpart.
 */
export type PayrollRunsWalletBalance = {
  /** Last digits of the funding account, e.g. "1234". */
  accountMask: string;
  availableBalance: number;
  currentBalance: number;
  pendingAmount: number;
};

type Input = {
  internalAccount?: InternalAccount;
  balance?: AccountBalance;
};

/** Adapt the funding internal account + its balance into the wallet card model. */
export const selectorPayrollRunsWalletBalance = ({
  internalAccount,
  balance
}: Input): PayrollRunsWalletBalance => {
  const amounts = selectorAccountBalance(balance);

  return {
    accountMask: takeRight(
      (internalAccount?.numbers?.account ?? "").split(""),
      4
    ).join(""),
    availableBalance: amounts.available,
    currentBalance: amounts.balance,
    pendingAmount: amounts.pending
  };
};
